import React from 'react'
import PropTypes from 'prop-types'

import { interval } from 'rxjs'
import { getTextTracks } from '../../../utils/text-track'
import { INTERVALS } from '../../../constants'

class CheckIfTextTrackExists extends React.PureComponent {
  // eslint-disable-next-line no-undef
  state = {
    isTextTrackExist: false,
    textTracks: null
  }

  componentDidMount() {
    this.showTextTracksSubscription = this.initializeTextTrackSubscription()
  }

  componentWillUnmount() {
    this.showTextTracksSubscription.unsubscribe()
  }

  // eslint-disable-next-line no-undef
  setTextTrackExist = textTracks => {
    this.setState({
      isTextTrackExist: true,
      textTracks
    })
  }

  // eslint-disable-next-line no-undef
  initializeTextTrackSubscription = () => {
    const subscription = interval(INTERVALS.TEXT_TRACK_EXIST_CHECK).subscribe(counter => {
      const { getTextTrackFromPlayer } = this.props

      if (counter >= 10 * 5) {
        subscription.unsubscribe()
      }
      const tracks = getTextTrackFromPlayer()

      const textTracks = getTextTracks(tracks)
      if (textTracks.length) {
        this.setTextTrackExist(textTracks)

        subscription.unsubscribe()
      }
    })

    return subscription
  }

  render() {
    const { children } = this.props
    if (!this.state.isTextTrackExist) return null
    return children(this.state.textTracks)
  }
}

CheckIfTextTrackExists.propTypes = {
  getTextTrackFromPlayer: PropTypes.func.isRequired
}

export default CheckIfTextTrackExists
